import classNames from "classnames";
import NewBareInput, {
  InputSize,
} from "components/DesignSystem/Input/BareInput";
import NewInput from "components/DesignSystem/Input/Input";
import React, { forwardRef, HTMLAttributes, ReactNode } from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  customSize?: InputSize;
  customType?: "error" | "success" | "warning";
  block?: boolean;
  name?: string;
  tooltipText?: string | ReactNode;
  icon?: ReactNode;
  customPrefix?: ReactNode;
  rightComponent?: ReactNode;
  required?: boolean;
  note?: ReactNode;
  hideError?: boolean;
  showErrorOnceTouched?: boolean;
}

export const BareInput = forwardRef(
  (
    {
      customSize = "regular",
      customType,
      tooltipText,
      customPrefix,
      icon,
      rightComponent,
      label,
      ...props
    }: InputProps,
    ref: React.Ref<HTMLInputElement>
  ) => (
    <NewBareInput
      ref={ref}
      customSize={customSize}
      variant={customType}
      infoText={tooltipText}
      leftComponent={customPrefix}
      rightComponent={icon ?? rightComponent}
      label={label}
      {...props}
    />
  )
);

export const Label = ({
  htmlFor,
  required = false,
  className,
  ...props
}: HTMLAttributes<HTMLLabelElement> & {
  htmlFor?: string;
  required?: boolean;
}) => (
  <label
    className={classNames(
      "t-text-body-sm t-text-text-60 t-pb-1.5",
      {
        "after:t-font-bold after:t-text-red-50 after:t-content-['_*']":
          required,
      },
      className
    )}
    htmlFor={htmlFor}
    {...props}
  />
);

/**
 * @deprecated Use Input from "components/DesignSystem/Input/Input" with withForm prop instead.
 */
export function TextInput({
  customType,
  tooltipText,
  customPrefix,
  icon,
  note,
  label,
  hideError,
  showErrorOnceTouched,
  name,
  ...props
}: InputProps) {
  return (
    <NewInput
      withForm
      name={name!}
      variant={customType}
      infoText={tooltipText}
      leftComponent={customPrefix}
      rightComponent={icon}
      label={label}
      helperText={typeof note === "string" ? note : undefined}
      hideError={hideError}
      showErrorOnceTouched={showErrorOnceTouched}
      {...props}
    />
  );
}
